import axios from 'axios';
import config from '../config';
const { BASE_API_URL } = config;

// For API without authentication method
export const axiosNoAuth = axios.create({
  baseURL: BASE_API_URL,
});